// removed by extract-text-webpack-plugin
module.exports = {"error":"error--1dAUX"};


//////////////////
// WEBPACK FOOTER
// ./client/components/product-type-selector/index.scss
// module id = 478
// module chunks = 0